import { http } from '@utils/index';

interface ResponseData {}

const csrf = () => {
	return http.get<APIResponse<ResponseData>>('/csrf');
};
export default csrf;
